/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import {
  queryIdToQuery,
  queryStringToQueryId,
  constructFolderItemQueryId,
} from 'ducks/searches/utils/query'
import { buildId } from 'util/globalId'
import { withToggle } from 'util/arrays'
import { CHAT_PAGE } from 'subapps/chat/pages'
import {
  SET_COLLECTIONS_BYID,
  TOGGLE_COLLECTION,
  OPEN_ONE_COLLECTION,
  BUILD_FROM_WIDGETS,
} from '../actionTypes/collections'

// Example of how the collections look in state
/*
{
  fc0: {
    id: 'fc0',
    type: 'pinned',
    name: 'Pinned',
    position: 1,
    queryId: 'inbox:4517239960',
    color: '#e5bb3e',
    hideName: false,
    icon: null,
    linkTo: null,
  }
}
*/

const collectionsByIdInitialState = {}

function buildCollectionQueryId(widgetId, folder) {
  return constructFolderItemQueryId({ widget: { id: widgetId }, folder })
}

export const collectionsById = createActionTypeReducer(
  {
    [SET_COLLECTIONS_BYID]: (_, { payload: { collections = [] } }) => {
      return collections.reduce((collectionById, collection) => {
        collectionById[collection.id] = collection
        return collectionById
      }, {})
    },
    [BUILD_FROM_WIDGETS]: (
      draftState,
      {
        payload: {
          widgets = [],
          folders = [],
          prefersAllMailboxesSectionVisible = false,
          prefersUnifiedInbox = false,
        },
      }
    ) => {
      const validIds = []
      const hasAccessToAtleastOneWidget = widgets.some(w => w.hasAccess)

      const allowedWidgets = prefersUnifiedInbox
        ? []
        : [...widgets.filter(w => w.hasAccess)]

      if (
        hasAccessToAtleastOneWidget &&
        (prefersUnifiedInbox ||
          (prefersAllMailboxesSectionVisible && allowedWidgets.length > 1))
      ) {
        allowedWidgets.unshift({
          id: '',
          name: 'All widgets',
          hasAccess: true,
        })
      }

      allowedWidgets.forEach((widget, index) => {
        const { id: widgetId, name, channelColor, kind: widgetKind } = widget
        const currentPosition = index + 1
        const id = widgetId ? buildId('Widget', widgetId) : ''
        validIds.push(id)
        const collectionQueryId = buildCollectionQueryId(widgetId, folders[0])
        const queryId = widgetId ? `widget:${widgetId}` : ''
        if (!draftState[id]) {
          draftState[id] = {
            id,
            widgetId,
            widgetKind,
            type: 'widget',
            queryId,
            name,
            position: currentPosition,
            color: channelColor || 'var(--color-monochrome-dark)',
            hideName: false,
            icon: false,
            linkTo: {
              type: CHAT_PAGE,
              payload: {},
              meta: {
                query: queryIdToQuery(collectionQueryId),
              },
            },
          }
        }
        draftState[id].position = currentPosition
      })
      Object.keys(draftState).forEach(id => {
        if (!validIds.includes(id)) {
          delete draftState[id]
        }
      })
      return draftState
    },
  },
  collectionsByIdInitialState
)

const openCollectionIdsInitialState = []

const currentOpenCollectionIdromQueryReducer = (draftState, action) => {
  // https://github.com/faceyspacey/redux-first-router/blob/master/docs/query-strings.md#where-query-lives-on-your-actions
  const { meta: { location: { current: { query = {} } = {} } = {} } = {} } =
    action || {}
  const { channelId = '', folderId } =
    queryIdToQuery(queryStringToQueryId(query)) || {}

  if (channelId || folderId) {
    return [channelId]
  }
  return draftState
}

export const openCollectionIds = createActionTypeReducer(
  {
    [CHAT_PAGE]: currentOpenCollectionIdromQueryReducer,
    [TOGGLE_COLLECTION]: (draftState, { payload: { collectionId } }) => {
      withToggle(draftState, collectionId)
    },
    [OPEN_ONE_COLLECTION]: (_, { payload: { collectionId } }) => {
      return [collectionId]
    },
  },
  openCollectionIdsInitialState
)
